import tw, { styled } from 'twin.macro';

export const StyledEventsActionbar = styled.div.attrs((props) => ({
  className: props.className
}))(({}) => [tw`flex justify-between content-center pt-8 pb-4`]);
